export default {
    currentQuestionGroup: {},
    currentQuestionGroupI10N: {},
    questionList: {},
    permissions: {},
    languages: [],
    survey: {},
    debugMode: false,
    activeLanguage: '',
    inTransfer: false
};